var map = {
	"./assets/images/petal-logo-dark.svg": 776,
	"./config/locales/en.json": 777,
	"./config/locales/fr_CA.json": 778
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 775;


//////////////////
// WEBPACK FOOTER
// ./hospital-booking \.(html|json|woff|woff2|ttf|eot|svg|gif|png|jpg)$
// module id = 775
// module chunks = 0